module.exports = __webpack_public_path__ + "static/1-af802b199264af67a31ae758ec52c2b2.png";